import Header from "../components/Header";
import Banner from "../components/Banner";
import GlobalMenu from "../components/GlobalMenu";
import Loader from "../components/Loader";
import Footer from "../components/Footer";
import styles from "../styles/homepage/Home.module.scss";

const Fallback = () => {
  return (
    <div className={styles.container}>
      <Header />
      <Banner />
      <GlobalMenu />
      <div className={styles.loader}>
        <Loader />
      </div>
      <Footer />
    </div>
  );
};

export default Fallback;
